import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { ThongTinTaiSan2 } from "./ThongTinTaiSan2";

import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import DanhSachTaiSanApi from "service/danhSachTaiSanApi";
import { getListTaiSan } from "actions/DanhSachTaiSan/";
import { pushNotification } from "utils/notifications";
import { ThuocTinhTaiSan2 } from "./ThuocTinhTaiSan2";
import TaiSanApi from "../../../service/taiSanApi";
import configs from "constants/configs";
export const ThemMoiTaiSan2 = (props) => {
  const dispatch = useDispatch();
  //const dataAddAndEdit = useSelector((state) => state.addAndEditTaiSan); //dinh nghia o rootreducer
  const dataSearch = useSelector((state) => state.dataSearchTaiSan);
  const initDataAddAndEditnew = {
    TaiSanID: "",
    MaTaiSan: "",
    GhiChu: "",
    TinhTrangID: 1,
    KhoID: "",
    LoaiTaiSan: "",
    TenTaiSan: "",
    Options: [],
    ImageList: [],
  };

  const [dataAddAndEditNew, setDataAddAndEdit] = useState(
    initDataAddAndEditnew
  );

  const [imageTaiSans, setImageTaiSans] = useState([]);
  // console.log(dataAddAndEditNew);
  //const onUpdateDataAndEdit = (value) => setDataAddAndEdit(value);

  const currentForm = useForm();
  const { handleSubmit } = currentForm;
  const [formValues, setFormValues] = useState(null);

  const initListHangTheChap = {
    AnhTaiSan: "",
    CategoryId: "",
    Code: "",
    LoaiTaiSan: 0,
    Note: "",
    PhiKho: 0,
    StoreID: 1,
    TenTaiSan: "",
    ThuocTinhTaiSan: [],
  };
  const [dataListHangTheChap, setListHangTheChap] =
    useState(initListHangTheChap);

  useEffect(() => {
    //    if (Object.keys(errors).length === undefined) {
    //   setFormValues(values);
    // }
    // if (formValues == null || Object.entries(formValues)) {
    // }
    if (props.TaiSanID > 0) {
      DanhSachTaiSanApi.getOneDetailTaiSan(props.TaiSanID).then((response) => {
        // // alert(response.data.ThongTinTaiSan.Code);
        // console.log(response.data.AnhTaiSan);
        setImageTaiSans(
          response.data.AnhTaiSan.map((item) => {
            return item.Url;
          })
        ); // set lạiđường dẫn url
        setDataAddAndEdit({
          ...dataAddAndEditNew,
          TaiSanID: props.TaiSanID,
          MaTaiSan: response.data.ThongTinTaiSan.Code,
          GhiChu: response.data.ThongTinTaiSan.Note,
          TinhTrangID: response.data.ThongTinTaiSan.TinhTrangTaiSan,
          KhoID: response.data.ThongTinTaiSan.StoreId,
          LoaiTaiSan: response.data.ThongTinTaiSan.LoaiTaiSan,
          TenTaiSan: response.data.ThongTinTaiSan.TenTaiSan,
          Options: response.data.ThuocTinh,
          ImageList: response.data.AnhTaiSan.map((item) => {
            return item.Url;
          }),
        });
      });
    }
  }, [props.TaiSanID]);
  const updateTTTaiSan = (value) => {
    setDataAddAndEdit(value);
    // console.log(dataAddAndEditNew);
  };
  // const updateKho = (value) => {
  //   setDataAddAndEdit({
  //     ...dataAddAndEditNew,
  //     TaiSanID: props.TaiSanID,
  //     MaTaiSan: response.data.ThongTinTaiSan.Code,
  //     GhiChu: response.data.ThongTinTaiSan.Note,
  //     TinhTrangID: response.data.ThongTinTaiSan.TinhTrangTaiSan,
  //     KhoID: response.data.ThongTinTaiSan.StoreId,
  //     LoaiTaiSan: response.data.ThongTinTaiSan.LoaiTaiSan,
  //     TenTaiSan: response.data.ThongTinTaiSan.TenTaiSan,
  //   });
  // };
  //Thông báo
  const initErrors = {
    tenTaiSan: "",
  };
  const [errors, setErrors] = useState(initErrors);
  const onSubmit = (dataTaiSan) => {
    if (dataAddAndEditNew.TaiSanID > 0) {
      if (dataAddAndEditNew.TenTaiSan === "") {
        setErrors({
          ...errors,
          tenTaiSan: "Nhập tên tài sản!",
        });
        return;
      }
      dataAddAndEditNew.ImageList = imageTaiSans.map(function (elem) {
        if (typeof elem.url !== "undefined") {
          return elem.url;
        } else {
          return elem;
        }
      });
      DanhSachTaiSanApi.editTaiSan(
        dataAddAndEditNew.TaiSanID,
        dataAddAndEditNew.MaTaiSan,
        dataAddAndEditNew.GhiChu,
        dataAddAndEditNew.TinhTrangID,
        dataAddAndEditNew.KhoID,
        dataAddAndEditNew.LoaiTaiSan,
        dataAddAndEditNew.TenTaiSan,
        dataAddAndEditNew.Options,
        dataAddAndEditNew.ImageList
      )
        .then((response) => {
          dispatch(getListTaiSan(dataSearch));
          setDataAddAndEdit("", "", "", 1, "", "", "", [], []); // trả về giá trị rỗng khi thêm mới lại
        })
        .then(
          (response) => props.onHide(),
          pushNotification(
            "Cập nhật tài sản thành công",
            "success",
            "TOP_CENTER",
            2000
          )
        );
    } else {
      if (dataAddAndEditNew.TenTaiSan === "") {
        setErrors({
          ...errors,
          tenTaiSan: "Nhập tên tài sản!",
        });
        return;
      }
      dataAddAndEditNew.ImageList = imageTaiSans.map(function (elem) {
        if (typeof elem.url !== "undefined") {
          return elem.url;
        } else {
          return elem;
        }
      });
      DanhSachTaiSanApi.addTaiSan(
        dataAddAndEditNew.TaiSanID,
        dataAddAndEditNew.MaTaiSan,
        dataAddAndEditNew.GhiChu,
        dataAddAndEditNew.TinhTrangID,
        dataAddAndEditNew.KhoID,
        dataAddAndEditNew.LoaiTaiSan,
        dataAddAndEditNew.TenTaiSan,
        dataAddAndEditNew.Options,
        dataAddAndEditNew.ImageList
      )
        .then((response) => {
          dispatch(getListTaiSan(dataSearch));
          setDataAddAndEdit("", "", "", 1, "", "", "", [], []);
        })
        .then(
          (response) => props.onHide(),
          pushNotification(
            "Thêm mới tài sản thành công",
            "success",
            "TOP_CENTER",
            2000
          )
        );
    }
  };

  // const [imageTaiSans, setImageTaiSans] = useState([]);
  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title  color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <img src="/app-assets/images/icon-them-moi-hop-dong-v2.png" />
          </span>{" "}
          {props.TaiSanID > 0 ? "Sửa" : "Thêm mới"} tài sản
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <form
        className="form tat-toan form-horizontal form-edit"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Modal.Body>
          <div className="form-body">
            <div className="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse196"
                className="card-header"
                href="#collapse196"
                aria-expanded="true"
                aria-controls="collapse196"
              >
                <a
                  className="card-title lead info collapsed"
                  href={() => false}
                >
                  <h3>Thêm mới tài sản</h3>
                </a>
              </div>
              <div
                id="collapse196"
                aria-labelledby="headingCollapse96"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="row">
                      <ThongTinTaiSan2
                        currentForm={currentForm}
                        datanew={dataAddAndEditNew}
                        update={updateTTTaiSan}
                        TaiSanID={props.TaiSanID}
                        errors={errors}
                        setErrors={setErrors}
                      />
                      <ThuocTinhTaiSan2
                        currentForm={currentForm}
                        datanew={dataAddAndEditNew}
                        update={updateTTTaiSan}
                        AnhTaiSan={imageTaiSans}
                        updateAnhTaiSan={setImageTaiSans}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          <button
            type="button"
            class="btn btn-new-main btn-closenew"
            href={() => false}
            onClick={props.onHide}
          >
            <span>
              <i class="mdi mdi-close"></i>
            </span>
            &nbsp; Đóng &nbsp;
          </button>
          <button className="btn btn-new-main btn-checknew" type="submit">
            <span>
              <img src="/app-assets/images/icon-save-v2-white.png" />
            </span>
            &nbsp; {props.TaiSanID > 0 ? "Cập nhật" : "Thêm mới"} &nbsp;
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};
